{
  "@context": "https://hubmapconsortium.github.io/ccf-ontology/ccf-context.jsonld",
  "@type": "ccf:Sample",
  "sample_type": {},
  "rui_location": {},
  "sections": {
    "@type": "ccf:Sample",
    "sample_type": {},
    "datasets": {
      "@type": "ccf:Dataset",
      "@embed": "@always"
    }
  },
  "datasets": {
    "@type": "ccf:Dataset",
    "@embed": "@always"
  }
}
